import { Form, Input, RequiredNotice } from 'components/Form';
import { InlineAlert } from 'components/InlineAlert';
import { PasswordChecklist } from 'components/PasswordChecklist';
import { useEmailContext } from 'context/email/email.context';
import { useProductContext } from 'context/product/product.context';
import * as S from 'pages/Products/pages/InternetProducts/pages/EmailSettings/email-settings.styles';
import React, { useEffect, useState } from 'react';
import { ContentUtil } from 'utils/content';

import { content } from './section-password.content';

const contentUtil = new ContentUtil({ content, componentName: 'SectionPassword' });

interface ISectionPasswordProps {
  emailAddress: string;
}

enum PasswordChangeState {
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_FAILED,
  PASSWORD_CHANGE_NONE,
}

export const SectionPassword = ({ emailAddress }: ISectionPasswordProps) => {
  const { isCobrowseSession, getCobrowseSession } = useProductContext();
  const [passwordChangeState, setPasswordChangeState] = useState<PasswordChangeState>(
    PasswordChangeState.PASSWORD_CHANGE_NONE
  );
  const { changePasswordEmailAddress } = useEmailContext();

  const onPasswordChangeSubmit = (data: { password: string }) => {
    return changePasswordEmailAddress(emailAddress, data.password)
      .then((response) => {
        const result = !!response?.data?.success;
        setPasswordChangeState(
          result ? PasswordChangeState.PASSWORD_CHANGE_SUCCESS : PasswordChangeState.PASSWORD_CHANGE_FAILED
        );
      })
      .catch(() => {
        setPasswordChangeState(PasswordChangeState.PASSWORD_CHANGE_FAILED);
      });
  };

  useEffect(() => {
    // check if is CoBrowse Session
    getCobrowseSession();
  }, []);

  return (
    <>
      {passwordChangeState === PasswordChangeState.PASSWORD_CHANGE_SUCCESS && (
        <InlineAlert
          type="success"
          onClose={() => setPasswordChangeState(PasswordChangeState.PASSWORD_CHANGE_NONE)}
          testid="password-change-success">
          {contentUtil.translateToString('successTitle')}
        </InlineAlert>
      )}
      {passwordChangeState === PasswordChangeState.PASSWORD_CHANGE_FAILED && (
        <InlineAlert
          type="error"
          onClose={() => setPasswordChangeState(PasswordChangeState.PASSWORD_CHANGE_NONE)}
          testid="password-change-failed">
          {contentUtil.translateToString('errorText')}
        </InlineAlert>
      )}

      {!isCobrowseSession && (
        <S.Form>
          <Form
            id="change-password-email-address-form"
            hideCancelButton
            testid="change-password-email-address-form"
            onSubmit={onPasswordChangeSubmit}
            buttonText={contentUtil.translateToString('update')}
            render={(formApi, validators, validateItem, comparePasswords) => (
              <>
                <p className="title">{contentUtil.translateToString('passwordSectionTitle')}</p>
                <RequiredNotice />
                <Input
                  name="password"
                  label={contentUtil.translateToString('password')}
                  autoComplete="new-password"
                  id="password"
                  type="password"
                  testid="password"
                  validate={[validators.required, validators.password]}
                  isRequired
                  error={validateItem('password')}
                  hideErrorLabel
                />
                <PasswordChecklist password={(formApi.values as { [key: string]: string }).password || ''} />
                <Input
                  name="passwordRepeat"
                  label={contentUtil.translateToString('passwordRepeat')}
                  id="passwordRepeat"
                  autoComplete="off"
                  type="password"
                  testid="passwordRepeat"
                  validate={[validators.required]}
                  isRequired
                  error={comparePasswords('password', 'passwordRepeat', formApi)}
                />
              </>
            )}
          />
        </S.Form>
      )}

      {isCobrowseSession && (
        <InlineAlert type="warning">{contentUtil.translateToString('isCobrowseSession')}</InlineAlert>
      )}
    </>
  );
};

export default SectionPassword;
